import { render, staticRenderFns } from "./FacultiesIndex.vue?vue&type=template&id=4e2002ec"
import script from "./FacultiesIndex.vue?vue&type=script&lang=js"
export * from "./FacultiesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports